import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-panel-reportes',
  templateUrl: './panel-reportes.component.html',
  styleUrl: './panel-reportes.component.scss'
})
export class PanelReportesComponent {
  @Input() SYS33CON    : string = '';
  @Input() arrFiltros  : any;
  @Input() Reportes    : any;

  constructor (private dataService: SharedService) {

  }


  ImprimirReporte(SYS44COD: number) {
    let strFORMATO = "PDF";
    let url =  "api/mantenimientos/VerReportePersonalizado/lstSYS44ARC";
    //let filtros =  { ...this.arrFiltros };
    let llaves = {SYS44COD : SYS44COD};

    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
      " , \"SYS44COD\"   : \"" + SYS44COD   + "\" " +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"FILTROS_DASHBOARD\"    : [" + this.arrFiltros + "]" +
      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify(llaves) + "]}";
    let arr = JSON.parse(strjson);

    let json = this.toJSON("IMPRIMIR", arr, url + "/" + SYS44COD );

    this.dataService.ConsultarWS(url + "/" + SYS44COD , json).subscribe(
      (datosResp: any) => {
        const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.dataURItoBlob(base64, strFORMATO);
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }

  dataURItoBlob(dataURI, strFORMATO) {
    let strType = "application/pdf";
    if (strFORMATO == "XLS") strType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  toJSON(operacion: string, arr: any[], url?: string, extra?: string, extra2?: string) {
    let jsonResult : any = {
      LLAVES: arr,
      URL: url !=  null ? url:"",
      OPERACION: operacion,
    }
    if(extra != '' && extra != null){
      jsonResult = Object.assign(jsonResult, JSON.parse('{' + extra + '}'));
    }
    if(extra2 != '' && extra2 != null){
      jsonResult = Object.assign(jsonResult, JSON.parse('{' + extra2 + '}'));
    }

    return jsonResult;
  }

}
